import { render, staticRenderFns } from "./review-modal.vue?vue&type=template&id=fc8fca52&"
import script from "./review-modal.vue?vue&type=script&lang=js&"
export * from "./review-modal.vue?vue&type=script&lang=js&"
import style0 from "./review-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc8fca52')) {
      api.createRecord('fc8fca52', component.options)
    } else {
      api.reload('fc8fca52', component.options)
    }
    module.hot.accept("./review-modal.vue?vue&type=template&id=fc8fca52&", function () {
      api.rerender('fc8fca52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/review-modal.vue"
export default component.exports